export default __webpack_public_path__ + "static/media/agencyEpic.8a3b8b9a.png";